/* eslint-disable max-len */
import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'rbx';
import moment from 'moment-timezone';

import { Input } from '../../../../components/elements';

const Box = styled.div`
  border: 1px solid #dbdbdb;
  padding: 1rem;
  margin: 0.2rem;
`;

const LinkButton = props => (
  <Button {...props} className={`${props.className} link-button`} />
);

const Details = ({ squarePosConfigurationData }) => {
  const [isCopiedAccessToken, setIsCopiedAccessToken] = useState(false);

  const copyAccessToken = text => {
    navigator.clipboard.writeText(text).then(
      () => {
        setIsCopiedAccessToken(true);

        setTimeout(() => {
          setIsCopiedAccessToken(false);
        }, 5000);
      },
      err => {
        console.error('Async: Could not copy text: ', err);
      },
    );
  };

  const [isCopiedRefreshToken, setIsCopiedRefreshToken] = useState(false);

  const copyRefreshToken = text => {
    navigator.clipboard.writeText(text).then(
      () => {
        setIsCopiedRefreshToken(true);

        setTimeout(() => {
          setIsCopiedRefreshToken(false);
        }, 5000);
      },
      err => {
        console.error('Async: Could not copy text: ', err);
      },
    );
  };

  return (
    <Box className="columns is-multiline">
      <div className="column is-6">
        <Input
          label="Business Name"
          value={squarePosConfigurationData?.square?.businessName}
          disabled
        />
      </div>
      <div className="column is-6">
        <Input
          label="Country"
          value={squarePosConfigurationData?.square?.country}
          disabled
        />
      </div>
      <div className="column is-6">
        <Input
          label="Currency"
          value={squarePosConfigurationData?.square?.currency}
          disabled
        />
      </div>
      <div className="column is-6">
        <Input
          label="Language Code"
          value={squarePosConfigurationData?.square?.languageCode}
          disabled
        />
      </div>
      <div className="column is-6">
        <Input
          label="Created At"
          value={
            squarePosConfigurationData?.square?.createdAt
              ? `${moment(squarePosConfigurationData?.square?.createdAt).format(
                  'DD/MM/YYYY',
                )} ${moment(
                  squarePosConfigurationData?.square?.createdAt,
                ).format('hh:mm A')}`
              : ''
          }
          disabled
        />
      </div>
      <div className="column is-6">
        <Input
          label="Access Token"
          value={squarePosConfigurationData?.square?.accessToken}
          disabled
          rightSideAction={
            <LinkButton
              type="button"
              onClick={e => {
                e.stopPropagation();
                if (!isCopiedAccessToken) {
                  copyAccessToken(
                    squarePosConfigurationData?.square?.accessToken,
                  );
                }
              }}
            >
              {isCopiedAccessToken ? 'copied' : 'Copy Access Token'}
            </LinkButton>
          }
        />
      </div>
      <div className="column is-6">
        <Input
          label="Refresh Token"
          value={squarePosConfigurationData?.square?.refreshToken}
          disabled
          rightSideAction={
            <LinkButton
              type="button"
              onClick={e => {
                e.stopPropagation();
                if (!isCopiedRefreshToken) {
                  copyRefreshToken(
                    squarePosConfigurationData?.square?.refreshToken,
                  );
                }
              }}
            >
              {isCopiedRefreshToken ? 'copied' : 'Copy Refresh Token'}
            </LinkButton>
          }
        />
      </div>
      <div className="column is-6">
        <Input
          label="Status"
          value={squarePosConfigurationData?.square?.status}
          disabled
        />
      </div>
      <div className="column is-6">
        <Input
          label="Id"
          value={squarePosConfigurationData?.square?.id}
          disabled
        />
      </div>
      <div className="column is-6">
        <Input
          label="Main Location Id"
          value={squarePosConfigurationData?.square?.mainLocationId}
          disabled
        />
      </div>
    </Box>
  );
};

export default Details;
